import { IconChevronDown, IconContentPaste } from 'components/icons';
import { gt, toString } from 'lodash';
import { DetailPageContext } from 'pages/[ket-qua-tim-kiem]/[chi-tiet-tin-rao]';
import { useContext, useEffect, useState } from 'react';

const MAX_HEIGH_PARAGRAPH = 224;

const PostContent = () => {
  const { realEstate } = useContext(DetailPageContext).pageData ?? {};
  const { postContent } = realEstate ?? {};
  const [isShowMore, setIsShowMore] = useState(true);
  const [clientHeight, setClientHeight] = useState<number>();
  const hasShowMore = gt(clientHeight, MAX_HEIGH_PARAGRAPH);

  const showMore = () => {
    setIsShowMore(!isShowMore);
  };

  useEffect(() => {
    setClientHeight(document.getElementById('post-content-paragraph')?.clientHeight);
  }, []);

  return (
    <div id='post-content' className='flex flex-col space-y-[16px]'>
      <div className='flex items-center space-x-[10px]'>
        <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
          <IconContentPaste className='h-[18px] w-[18px]' />
        </div>
        <h2 className='text-[18px] font-[600] leading-[23px]'>Nội dung tin đăng</h2>
      </div>
      <div className='flex flex-col items-center'>
        <div
          id='post-content-paragraph'
          className={`w-full truncate whitespace-pre-wrap leading-[20px] ${
            hasShowMore && isShowMore ? 'line-clamp-[10]' : ''
          }`}
          dangerouslySetInnerHTML={{ __html: toString(postContent) }}
        />
        {hasShowMore && (
          <button
            type='button'
            className='flex items-center space-x-[4px] text-primary'
            onClick={showMore}
          >
            <span className='leading-[25px]'>{isShowMore ? 'Xem thêm' : 'Ẩn bớt'}</span>
            <IconChevronDown
              className={`min-h-[24px] min-w-[24px] transition duration-[200ms] ease-in-out ${
                isShowMore ? '' : 'rotate-180'
              }`}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default PostContent;
